export class Login{
    public USUARIO: string = ''
    public SENHA: string = ''
    constructor(u: string, p: string){
        this.USUARIO = u
        this.SENHA = p
    }
  }